import moment from "moment";
import { GripVertical, Trash2 } from "lucide-react";
import FormField from "../../components/FormField";
import IconButton from "../../components/IconButton";
import SearchSelect from "../../components/SearchSelect";
import TextInput from "../../components/TextInput";
import { shouldUpdateLinkedDate } from "../../../Helpers/linkedDates";

const errorFor = (errors, path) => errors?.[path]?.[0] || "";
const toLocal = (value) => value && moment(value).isValid() ? moment(value).format("YYYY-MM-DDTHH:mm") : "";
const toStored = (value) => value && moment(value).isValid() ? moment(value).toISOString() : value;

const ESUser = (props) => {
  const userData = props.userData || {};
  const userIndex = props.userIndex;
  const valuePath = `users.esusers.${userIndex}`;
  const options = (props.userOptions || []).map((user) => ({ label: user.name, value: user.id || user._id, user }));
  const selected = options.find((option) => option.value === userData.user_id) || null;
  const chooseUser = (option) => props.handleInputChange(valuePath, option ? { user_id: option.value, name: option.user.name, start_date: userData.start_date, end_date: userData.end_date, phone_no: option.user.phone_no } : {});
  const changeEndDate = (value) => {
    const storedValue = toStored(value);
    props.handleInputChange(`${valuePath}.end_date`, storedValue);
    const followingUser = props.allEsUsers[userIndex + 1];
    if (followingUser && shouldUpdateLinkedDate(followingUser.start_date, userData.end_date)) {
      props.handleInputChange(`users.esusers.${userIndex + 1}.start_date`, storedValue);
    }
  };

  return (
    <article className={["wsm-pack-form-section__entry", props.isDragging && "wsm-pack-form-section__entry--dragging"].filter(Boolean).join(" ")}>
      <div className="wsm-pack-form-section__entry-heading">
        <h4>Supervisor {userIndex + 1}</h4>
        <div className="wsm-pack-form-section__entry-actions">
          <IconButton
            {...props.dragHandleProps}
            aria-label={`Reorder supervisor ${userIndex + 1}`}
            disabled={props.allEsUsers.length < 2}
            icon={GripVertical}
            size="compact"
          />
          <IconButton aria-label={`Remove supervisor ${userIndex + 1}`} disabled={userIndex === 0} icon={Trash2} onClick={() => props.handleRemoveFormRow("users.esusers", userIndex, true, "engineering supervisor")} size="compact" variant="destructive" />
        </div>
      </div>
      <div className="wsm-pack-form__field-grid">
        <SearchSelect error={errorFor(props.errors, `data.users.esusers.${userIndex}.name`)} id={`es-user-${userIndex}`} isClearable label="Engineering supervisor" loading={props.usersLoading} onChange={chooseUser} options={options} placeholder="Select a person" required value={selected} />
        <FormField error={errorFor(props.errors, `data.users.esusers.${userIndex}.start_date`)} id={`es-start-${userIndex}`} label="Shift start" required>{(fieldProps) => <TextInput {...fieldProps} max={toLocal(props.plannedEndDate)} min={toLocal(props.plannedStartDate)} onChange={(event) => props.handleInputChange(`${valuePath}.start_date`, toStored(event.target.value))} type="datetime-local" value={toLocal(userData.start_date)} />}</FormField>
        <FormField error={errorFor(props.errors, `data.users.esusers.${userIndex}.end_date`)} id={`es-end-${userIndex}`} label="Shift end" required>{(fieldProps) => <TextInput {...fieldProps} max={toLocal(props.plannedEndDate)} min={toLocal(props.plannedStartDate)} onChange={(event) => changeEndDate(event.target.value)} type="datetime-local" value={toLocal(userData.end_date)} />}</FormField>
      </div>
    </article>
  );
};

export default ESUser;
